// Press Release Content for: Comsense Technologies Wins Three Prestigious MarTech Awards
// This data is imported and used by PressReleaseDetails.jsx

import feConnectAwardsImage from "../../../assets/images/press-releases/FEConnectAwards.jpg";

export const pressReleaseContent = {
  "comsense-technologies-wins-three-prestigious-martech-awards-for-customer-experience-and-marketing-innovation":
    {
      title:
        "Comsense Technologies Wins Three Prestigious MarTech Awards for Customer Experience and Marketing Innovation",
      sections: [
        {
          type: "image",
          src: feConnectAwardsImage,
          alt: "Comsense Technologies receiving the FE Connect MarTech Awards 2026",
          caption: "Comsense Technologies at the MarTech Awards 2026, presented by Financial Express and FE Connect.",
        },
        {
          type: "paragraph",
          content: "Gurugram, India; 28 May 2026",
        },
        {
          type: "paragraph",
          content:
            "Comsense Technologies, a leading Data, AI, and Customer Intelligence company, has been honored with three prestigious MarTech Awards, recognizing its work in delivering data-driven customer engagement, marketing analytics, and customer experience transformation for leading automotive brands.",
        },
        {
          type: "paragraph",
          content: "The company received the following awards:",
        },
        {
          type: "list",
          items: [
            "<strong>Excellence in Marketing Automation & Journey Orchestration</strong> for its work with <strong>Tata Motors Ltd</strong>.",
            "<strong>Excellence in Marketing Analytics & Insight Platform </strong>for its work with <strong>Royal Enfield India</strong>",
            "<strong>Excellence in the Use of MarTech in Automotive </strong>for its work with <strong>Royal Enfield India</strong>",
          ],
        },
        {
          type: "paragraph",
          content:
            "The awards, presented by Financial Express and FE Connect, recognize organizations that are leveraging marketing technology to create measurable business impact, improve customer engagement, and drive innovation across industries.",
        },
        {
          type: "paragraph",
          content:
            "These recognitions reflect Comsense's commitment to helping enterprises transform customer data into actionable intelligence, enabling better decision-making, enhanced customer experiences, and sustainable business growth.",
        },
        {
          type: "paragraph",
          content:
            "Over the years, Comsense has worked closely with leading enterprises to build customer intelligence platforms, advanced analytics capabilities, AI-powered solutions, and personalized customer engagement programs. The award-winning initiatives with Tata Motors and Royal Enfield demonstrate how organizations can unlock greater value from their customer data and marketing technology investments.",
        },
        {
          type: "paragraph",
          content:
            "While the awards mark an important milestone, Comsense views them as a reflection of a larger mission: enabling organizations to create stronger customer relationships, accelerate growth, and make smarter business decisions through Data and AI.",
        },
        {
          type: "paragraph",
          content:
            "As enterprises continue to navigate digital transformation and AI adoption, Comsense remains committed to helping businesses unlock the full potential of customer intelligence and emerging technologies.",
        },
        {
          type: "heading",
          level: 2,
          content: "About Comsense Technologies",
        },
        {
          type: "paragraph",
          content:
            "Comsense Technologies is a Data, AI, and Customer Intelligence company that helps enterprises transform customer data into business growth. Through advanced analytics, AI-powered solutions, customer intelligence platforms, and digital transformation initiatives, Comsense enables organizations to improve customer experience, retention, revenue growth, and marketing effectiveness.",
        },
      ],
    },
};

export default pressReleaseContent;
